import { render, staticRenderFns } from "./BankKeywords.vue?vue&type=template&id=b645e6d6"
import script from "./BankKeywords.vue?vue&type=script&lang=js"
export * from "./BankKeywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports